import Ticket from '../model/ticket';

/**
 * Ticket service
 * @type {{init: (function()), getTicketSvc: (function())}}
 */

export const TicketSvc = {
  /**
   * Initialize ticket service
   */
  init() {
    this.ticketSVc = new Ticket();
  },

  /**
   * Get ticket service
   * @returns {Ticket | TicketSvc}
   */
  getTicketSvc() {
    return this.ticketSVc;
  },
};



// WEBPACK FOOTER //
// ticket.service.js